document.addEventListener("DOMContentLoaded", function () {

  const form = document.querySelector("form[action*='contact']");
  if (!form) return;

  const button = form.querySelector(".contact__button button");

  const nameInput = form.querySelector(".wac-name");
  const emailInput = form.querySelector(".wac-email");
  const phoneInput = form.querySelector(".wac-phone");
  const commentInput = form.querySelector(".wac-comment");

  function showError(input, message) {
    removeError(input);

    const error = document.createElement("small");
    error.className = "contact__field-error";
    error.textContent = message;

    input.closest(".field").appendChild(error);
    input.classList.add("input-error");
  }

  function removeError(input) {
    const field = input.closest(".field");
    const existingError = field.querySelector(".contact__field-error");

    if (existingError) existingError.remove();
    input.classList.remove("input-error");
  }

  /* -------------------------
     SANITIZER FUNCTIONS
  ------------------------- */

  function sanitizeName() {
    let cleaned = nameInput.value
      .replace(/[^a-zA-Z\s]/g, "")
      .replace(/^\s+/, "")
      .replace(/\s{2,}/g, " ");

    nameInput.value = cleaned;
  }

  function sanitizeEmail() {
    emailInput.value = emailInput.value.replace(/\s/g, "");
  }

  function sanitizePhone() {
    let cleaned = phoneInput.value.replace(/[^0-9]/g, "");

    if (cleaned.length > 10) {
      cleaned = cleaned.slice(0, 10);
    }

    phoneInput.value = cleaned;
  }

  function sanitizeComment() {
    if (commentInput.value.length > 100) {
      commentInput.value = commentInput.value.slice(0, 1200);
    }
  }

  /* -------------------------
     INSTANT SANITIZATION EVENTS
  ------------------------- */

  ["input","paste","change"].forEach(evt => {
    nameInput.addEventListener(evt, sanitizeName);
    emailInput.addEventListener(evt, sanitizeEmail);
    phoneInput.addEventListener(evt, sanitizePhone);
    commentInput.addEventListener(evt, sanitizeComment);
  });

  /* -------------------------
     KEYBOARD RESTRICTIONS
  ------------------------- */

  nameInput.addEventListener("keydown", function(e) {

    const key = e.key;

    if (
      key === "Backspace" ||
      key === "Delete" ||
      key === "ArrowLeft" ||
      key === "ArrowRight" ||
      key === "Tab"
    ) return;

    if (/^[a-zA-Z]$/.test(key)) return;

    if (key === " ") {
      if (this.value.length === 0 || this.value.slice(-1) === " ") {
        e.preventDefault();
      }
      return;
    }

    e.preventDefault();
  });

  phoneInput.addEventListener("keydown", function(e) {

    const key = e.key;

    if (
      key === "Backspace" ||
      key === "Delete" ||
      key === "ArrowLeft" ||
      key === "ArrowRight" ||
      key === "Tab"
    ) return;

    if (/^[0-9]$/.test(key)) {

      if (this.value.length >= 10) {
        e.preventDefault();
      }

      return;
    }

    e.preventDefault();
  });

  /* -------------------------
     INITIAL SANITIZE (AUTOFILL FIX)
  ------------------------- */

  setTimeout(function(){
    sanitizeName();
    sanitizeEmail();
    sanitizePhone();
    sanitizeComment();
  }, 50);

  /* -------------------------
     FORM VALIDATION
  ------------------------- */

  function validate() {

    let valid = true;

    const name = nameInput.value.trim();
    const email = emailInput.value.trim();
    const phone = phoneInput.value.trim();
    const comment = commentInput.value.trim();

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    removeError(nameInput);
    removeError(emailInput);
    removeError(phoneInput);
    removeError(commentInput);

    if (name === "") {
      showError(nameInput, "Name is required");
      valid = false;
    }

    if (email === "") {
      showError(emailInput, "Email is required");
      valid = false;
    }
    else if (!emailPattern.test(email)) {
      showError(emailInput, "Please enter a valid email");
      valid = false;
    }

    if (phone === "") {
      showError(phoneInput, "Phone number is required");
      valid = false;
    }
    else if (phone.length !== 10) {
      showError(phoneInput, "Phone number must be 10 digits");
      valid = false;
    }

    if (comment === "") {
      showError(commentInput, "Message is required");
      valid = false;
    }
    else if (comment.length > 100) {
      showError(commentInput, "Message cannot exceed 100 characters");
      valid = false;
    }

    return valid;
  }

  /* -------------------------
     SUBMIT
  ------------------------- */

  button.addEventListener("click", function () {

    if (validate()) {
      form.submit();
    }

  });

});